<template>
    <div class="content-window-container"
         v-observe-visibility="visibilityChanged"
         :id="pageID">
        <div class="container">
            <div class="window-title will-animate"  data-ani="animated fadeInDown">{{$t('Page.Product.Title')}}</div>
            <div class="window-subtitle will-animate clear" data-ani="animated fadeInDown"><div>{{$t('Page.Product.Subtitle')}}</div></div>

            <div class="window-content">
                <common-content
                        :prefix="'product'"
                        :content="this.$t('Page.Product.Content')"
                        :icon="icon"/>
            </div>
        </div>
    </div>
</template>

<script>
  import {pageMounted, basicPageMethods} from "../js/common"
  import {scNamespace} from "../js/scNamespace"
  import CommonContent from "../components/commonContent"

  export default {
    components: {CommonContent},
    name: "product",
    mounted: pageMounted,
    data() {
      return {
        icon: [
          require('../assets/page/product/collaboration.png'),
          require('../assets/page/product/supply.png'),
          require('../assets/page/product/data.png'),
          require('../assets/page/product/marketing.png'),
        ],
        pageID: scNamespace.PAGE.PRODUCT.id
      }
    },
    methods: {
      ...basicPageMethods(),
      localMounted() {

      },
    }
  }
</script>